<div class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Gérer les copropriétaires</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    <fieldset class="mb-0">
      <legend>Les copropriétaires</legend>
    </fieldset>
    <div class="table-responsive">
      <table class="table table-borderless">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          @for (owner of owners; track owner) {
            <tr>
              <td data-user-lastname="">{{ owner.lastname }}</td>
              <td data-user-firstname="">{{ owner.firstname }}</td>
              <td data-user-email="">{{ owner.email }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
  <div class="m-2 p-4 bg-white rounded">
    <fieldset class="mb-0">
      <legend>Ajouter un copropriétaire</legend>
    </fieldset>
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()" class="pb-4">
        @if (form.get('civility'); as control) {
          <div class="mb-3 col-12">
            <label for="civility">Civilité *</label>
            <select class="form-control" id="civility" formControlName="civility"
              [ngClass]="{'is-invalid': !control.valid}">
              <option value="MONSIEUR" selected="selected">MONSIEUR</option>
              <option value="MADAME">MADAME</option>
            </select>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (form.get('lastname'); as control) {
          <div class="mb-3 col-12">
            <label for="lastname">Nom *</label>
            <input class="form-control" id="lastname" type="text"
              formControlName="lastname" [ngClass]="{'is-invalid': !control.valid}">
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (form.get('firstname'); as control) {
          <div class="mb-3 col-12">
            <label for="firstname">Prenom *</label>
            <input class="form-control" id="firstname" type="text"
              formControlName="firstname" [ngClass]="{'is-invalid': !control.valid}">
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (form.get('email'); as control) {
          <div class="mb-3 col-12">
            <label for="lastname">Adresse email *</label>
            <input class="form-control" id="email" type="email"
              formControlName="email" [ngClass]="{'is-invalid': !control.valid}">
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        <div class="text-end mt-3">
          <button type="submit" class="btn btn-blue">
            Enregistrer
          </button>
        </div>
      </form>
    }
  </div>
</div>
